// Libs
import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import Masonry from 'react-masonry-component'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
// import CountUp from 'react-countup'
// Components
import Simple from '../shared/SimpleCard'
import Double from '../shared/DoubleCard'
import FixedFabButton from '../shared/FixedFabButton'
import ClassChips from "./ClassChips";
// Store
import { addFactoid, removeFactoid } from './duck/actions'
// Helpers
import { IStoreState, IProfileState } from '../lib/interface'
import { getRelatedFactoidsFromClass, getFactoidWidth, isSimpleFactoidLayout, sortCardSizes } from '../lib/helpers'

import * as _ from 'lodash';


interface IProps extends RouteComponentProps<{}> {
  factoidData: any[]
  classSelections: number[]
  addFactoid: (id: number, businessLineId: number) => void
  removeFactoid: (id: number, businessLineId: number) => void
  factoidSelections: number[]
  profile: IProfileState
  businessLines: any[]
}

class Factoids extends React.Component<IProps, {}> {

  public masonries:any[] = [];

  public componentDidMount() {
    if (!this.props.classSelections.length) {
      this.props.history.push('/views/new')
    }

    window.addEventListener("orientationchange", this.handleResize);

    (window as any).masonries = this.masonries;

  }

  public componentWillUnmount() {
    window.removeEventListener("orientationchange", this.handleResize);
  }

  public handleResize = () => {
    if(window.orientation && window.orientation === 90 || window.orientation === "270"){
      setTimeout(() => this.masonries.forEach((m:any) => m.masonry.layout()), 1000)
    }
  }

  

  public handleFactoidSelect = (id: number, businessLineId: number) => {
    this.props.addFactoid(id, businessLineId)
  }

  public handleFactoidRemove = (id: number, businessLineId: number) => {
    this.props.removeFactoid(id, businessLineId)
  }

  public next = () => {
    this.props.history.push('/views/new/review')
  }


  public sortFactoidsBasedOnBu = () => {
    const { businessLines, classSelections, factoidData} = this.props
    // Agent selected BU details
    const agentBUId = this.props.profile.businessUnit.id
    const agentBU = businessLines.length ? businessLines.find((bl: any) => bl.id === agentBUId) : false
    // Factoids that are relevant based on class
    const activeClassFactoids: any[] = getRelatedFactoidsFromClass(classSelections, factoidData)
    // Factoids that are related to the agent selected BU
    // const activeBUFactoids = agentBU ? factoidData.filter((factoid: any) =>  classSelections.some((classId: number) =>
    // factoid.business_line.length && factoid.business_line[0] === agentBUId)) : []
    const activeBUFactoids = agentBU ? factoidData.filter((factoid: any) =>  factoid.business_line.length && factoid.business_line[0] === agentBUId) : []
    // Ids of BU's related to agent selected BU
    const relatedBUIds = agentBU.acf.related_business_lines.length > 0 ? agentBU.acf.related_business_lines.map((bl: any) => bl.term_id) : []
    // Factoids that are relevant to the related BU's
    const activeRelatedBUFactoids = factoidData.filter((factoid: any) => relatedBUIds.some((buId: number) =>
    factoid.business_line.includes(buId)));

    const activeRelatedGrouped = _.groupBy(activeRelatedBUFactoids.map(f => ({...f, bl: f.business_line[0]})), 'bl');
    const activeRelatedGroupedArray:any = Object.keys(activeRelatedGrouped).map((group:any) => activeRelatedGrouped[group]);
    

    const activeRelatedBUFactoidIds = activeRelatedBUFactoids.map((factoid: any) => factoid.id)
    // Needed to help filter out and determine which factoids are left
    const activeBUFactoidIds = activeBUFactoids.map((factoid: any) => factoid.id)
     
    // @ts-ignore
    const usedFactoids:array = [...activeBUFactoidIds, ...activeRelatedBUFactoidIds];
    const remainingFactoids = activeClassFactoids
      .filter((factoid: any) => !usedFactoids.includes(factoid.id))

    const groupedRemaingFactoids:object = _.groupBy(remainingFactoids
      .map(f => ({ ...f, bl: f.business_line[0] })), 'bl');

    const groupedRemaingFactoidsArray:any[] = Object.keys(groupedRemaingFactoids).map((group:any) => groupedRemaingFactoids[group]);
    
    // const reducedGroupedRemainingFactoids: any[] = Object.keys(groupedRemaingFactoids).reduce((accumulator, groupKey) => {
    //   const group: any[] = groupedRemaingFactoids[groupKey];
    //   return [...accumulator, ...group]
    // }, []);

    return {
      active: activeBUFactoids,
      // related: activeRelatedBUFactoids,
      groupedRelated: activeRelatedGroupedArray,
      // classRelated: reducedGroupedRemainingFactoids,
      groupedRemaining: groupedRemaingFactoidsArray,
    }
  }

  public render() {
    const { classSelections, factoidData} = this.props
    // factoids that are relevant based on the current asset classes selected.
    const activeFactoids: any[] = getRelatedFactoidsFromClass(classSelections, factoidData)

    const renderFactoidsBasedOnBU = () => {
      const { active, groupedRelated, groupedRemaining } = this.sortFactoidsBasedOnBu()


      return (
        <div>
          <Masonry
          options={{ transitionDuration: 0 }}
          // @ts-ignore
          updateOnEachImageLoad={true}
          ref={ref => this.masonries.push(ref)}
          >
          {sortCardSizes(active).map((factoid: any, index: number): React.ReactNode => {
            /**
             * @todo, double width *col-sm-8* not working, screws up the masonry layout
             */
            const width = getFactoidWidth(factoid)

            if (isSimpleFactoidLayout(factoid)) {
              return (
                <FactoidOuter className={width} key={`${factoid.id} - ${index}`}>
                
                  <Simple
                    item={factoid}
                    onSelect={this.handleFactoidSelect}
                    onRemove={this.handleFactoidRemove}
                  />
                </FactoidOuter>
              )
            } else {
              return (
                <FactoidOuter className={width} key={`${factoid.id} - ${index}`}>
                  
                  <Double
                    item={factoid}
                    onSelect={this.handleFactoidSelect}
                    onRemove={this.handleFactoidRemove}
                  />
                </FactoidOuter>
              )
            }
          })}
        </Masonry>

        {
          groupedRelated.map((group:any, i:number) => {
            return (<Masonry
              options={{transitionDuration: 0}}
              updateOnEachImageLoad={true}
              key={i}
              ref={ref => this.masonries.push(ref)}
              >
                {
                  sortCardSizes(group).map((factoid: any, index: number): React.ReactNode => {
                    /**
                     * @todo, double width *col-sm-8* not working, screws up the masonry layout
                     */
                    const width = getFactoidWidth(factoid)
        
                    if (isSimpleFactoidLayout(factoid)) {
                      return (
                        <FactoidOuter className={width} key={`${factoid.id} - ${index}`}>
                             
                          <Simple
                            item={factoid}
                            onSelect={this.handleFactoidSelect}
                            onRemove={this.handleFactoidRemove}
                          />
                        </FactoidOuter>
                      )
                    } else {
                      return (
                        <FactoidOuter className={width} key={`${factoid.id} - ${index}`}>
                             
                          <Double
                            item={factoid}
                            onSelect={this.handleFactoidSelect}
                            onRemove={this.handleFactoidRemove}
                          />
                        </FactoidOuter>
                      )
                    }
                  })
                }
              </Masonry>)
          })
        }
        {
          groupedRemaining.map((group:any, i) => {
            return (<Masonry
              options={{transitionDuration: 0}}
              updateOnEachImageLoad={true}
              key={i}
              ref={ref => this.masonries.push(ref)}
              >
                {
                  sortCardSizes(group).map((factoid: any, index: number): React.ReactNode => {
                    /**
                     * @todo, double width *col-sm-8* not working, screws up the masonry layout
                     */
                    const width = getFactoidWidth(factoid)
        
                    if (isSimpleFactoidLayout(factoid)) {
                      return (
                        <FactoidOuter className={width} key={`${factoid.id} - ${index}`}>
                             
                          <Simple
                            item={factoid}
                            onSelect={this.handleFactoidSelect}
                            onRemove={this.handleFactoidRemove}
                          />
                        </FactoidOuter>
                      )
                    } else {
                      return (
                        <FactoidOuter className={width} key={`${factoid.id} - ${index}`}>
                             
                          <Double
                            item={factoid}
                            onSelect={this.handleFactoidSelect}
                            onRemove={this.handleFactoidRemove}
                          />
                        </FactoidOuter>
                      )
                    }
                  })
                }
              </Masonry>)
          })
        }
        
      </div>
      )

    }

    // elements to render in masonry
    const allFactoids =  sortCardSizes(activeFactoids).map((factoid: any): React.ReactNode => {

      const width = getFactoidWidth(factoid)

      if (isSimpleFactoidLayout(factoid)) {
        return (
          <FactoidOuter className={width} key={factoid.id}>
            <Simple
              item={factoid}
              onSelect={this.handleFactoidSelect}
              onRemove={this.handleFactoidRemove}
            />
          </FactoidOuter>
        )
      } else {
        return (
          <FactoidOuter className={width} key={factoid.id}>
            <Double
              item={factoid}
              onSelect={this.handleFactoidSelect}
              onRemove={this.handleFactoidRemove}
            />
          </FactoidOuter>
        )
      }
    })

    return (
      <Outer>
        <ClassChips />
        <div className="container-fluid">
          <div className="row">
          {this.props.profile.businessUnit.id && this.props.businessLines.length ? 
            renderFactoidsBasedOnBU()
            :
            <Masonry
              options={{ transitionDuration: 0 }}
              // @ts-ignore
              updateOnEachImageLoad={true}
              >
              {allFactoids}
            </Masonry>
          }
          </div>
        </div>
        <FixedFabButton
          onClick={this.next}
          disabled={!this.props.factoidSelections.length ? true : false}
        >
          <ArrowForwardIcon />
        </FixedFabButton>
      </Outer>
    )
  }
}

const mapStateToProps = (state: IStoreState) => ({
  classSelections: state.views.new.selections.classes,
  factoidData: state.data.factoids,
  factoidSelections: state.views.new.selections.factoids,
  profile: state.profile,
  businessLines: state.data.businessLines
})

export default withRouter(
  connect(
    mapStateToProps,
    { addFactoid, removeFactoid }
  )(Factoids)
)

const Outer = styled.div`
  position: relative;
  width: 95%;
  margin: 0 auto;
  h2 {
    color: #717271;
    font-weight: 400;
  }

  .masonry {
    display: flex;
    flex-direction: row;
  }

`

const FactoidOuter = styled.div`
  margin: 10px 0;
  transition: all 0.5s;
`



// WEBPACK FOOTER //
// ./src/views/Factoids.tsx